import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import OrganisationLayer from "../components/OrganisationLayer";

const OrganisationPage = () => (
  <MasterLayout pageTitle="Organisation">
    <OrganisationLayer />
  </MasterLayout>
);

export default OrganisationPage;
